import Modals from './Modals.vue'
import { events }    from './events'

const Modal = {
  install(Vue, args = {}) {
    if (this.installed) {
      return
    }

    this.installed = true
    this.params = args

    Vue.component(args.componentName || 'modals', Modals)

    const modal = (params) => {
      if (typeof params === 'string') {
        params = { title: '', url: params,text:'' }
      }

      if (typeof params === 'object') {
        events.$emit('show', params)
      }
    }

    const name = args.name || 'modal'

    Vue.prototype['$' + name] = modal
    Vue[name] = modal
  }
}

export default Modal